// ThankYouModal.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './thankyou.css';  // Optional CSS styling

const ThankYouModal = ({ isVisible, onClose }) => {
  const navigate = useNavigate();

  const handleOkayClick = () => {
    onClose();  // Close the modal
    navigate('/home');  // Navigate to home page
  };

  if (!isVisible) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Thank You!</h2>
        <p>Your form has been submitted successfully.</p>
        <button onClick={handleOkayClick}>Okay</button>
      </div>
    </div>
  );
};

export default ThankYouModal;
